import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, timeout} from 'rxjs/operators';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
    constructor() {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        const timeoutDurationInMillis = 30000; // 30 seconds
        return next.handle(request).pipe(
            timeout(timeoutDurationInMillis),
            catchError((error) => {
                if (error.name === 'TimeoutError') {
                    console.error('TimeoutInterceptor error for:', request.url);
                }
                return throwError(error);
            })
        );
    }
}
